export enum WalletItemType {
  Marketplace = 1,
  Lotto = 2,
  Auction = 3,
}
